export const DASHBOARD_VERSION = 1;
export const DASHBOARD_GRID_COLUMNS = 12;

export const dashboardWidgetTypes = [
    "sales_analytics",
    "active_projects",
    "revenue",
    "outstanding",
    "orphaned_payments",
    "recent_calls",
    "asset_services",
    "unread_email",
    "upcoming_asset_services",
    "pending_hours",
    "pending_documents",
    "open_invoices",
    "worker_client_balance",
] as const;

export type DashboardWidgetType = typeof dashboardWidgetTypes[number];

export interface DashboardWidgetPosition {
    x: number;
    y: number;
    width: number;
    height: number;
}

export interface DashboardWidgetInstance {
    id: string;
    type: DashboardWidgetType;
    settings: Record<string, number>;
    position: DashboardWidgetPosition;
}

export interface DashboardConfig {
    version: number;
    widgets: DashboardWidgetInstance[];
}
